export function getAll() {
  const customerDegreeName = JSON.parse(
    window.localStorage["customerDegreeName"]
  );
  return [
    {
      value: 1,
      name: "Level1",
      text: customerDegreeName.CustomerDegreeOne || "一級",
    },
    {
      value: 2,
      name: "Level2",
      text: customerDegreeName.CustomerDegreeTwo || "二級",
    },
    {
      value: 3,
      name: "Level3",
      text: customerDegreeName.CustomerDegreeThree || "三級",
    },
    {
      value: 4,
      name: "Level4",
      text: customerDegreeName.CustomerDegreeFour || "四級",
    },
    {
      value: 5,
      name: "Level5",
      text: customerDegreeName.CustomerDegreeFive || "五級",
    },
    {
      value: 6,
      name: "Level6",
      text: customerDegreeName.CustomerDegreeSix || "六級",
    },
  ];
}
